module.exports = __webpack_public_path__ + "static/media/do1.42cc6cba.png";